import { takeUntil } from 'rxjs/operators';
import { CompanyService } from './../../../../../providers/services/company.service';
import { Component, OnInit, Input, SimpleChanges } from '@angular/core';
import { Product, Company } from '@pdp/common';
import { Subject } from 'rxjs';
import { NgIf, NgFor, SlicePipe } from '@angular/common';
import { ProductBoxVerticalTwoComponent } from '../../two/product-box-vertical-two/product-box-vertical-two.component';
import { ProductBoxTwoComponent } from '../../two/product-box-two/product-box-two.component';

@Component({
    selector: 'pdp-special-products-two',
    templateUrl: './special-products-two.component.html',
    styleUrls: ['./special-products-two.component.scss'],
    imports: [NgIf, NgFor, ProductBoxVerticalTwoComponent, ProductBoxTwoComponent, SlicePipe]
})
export class SpecialProductsTwoComponent implements OnInit {

  protected unsubscribe: Subject<void> = new Subject();

  public company: Company;
  @Input() 
  public products: Product;

  @Input()
  public promotionMessage: string;

  @Input()
  public displayPromotionMessage: boolean;
  
  constructor(public companyService: CompanyService) { }

  ngOnInit() { 
    this.companyService.getValue.pipe(takeUntil(this.unsubscribe)).subscribe((company: Company)=>{
      this.company = company;
    })
  }
  

  ngOnChanges(value: SimpleChanges) {}

  ngOnDestroy() {
    this.unsubscribe.next(undefined);
    this.unsubscribe.complete();
  }

}
